import http from "../../http-common";

class service {

  url = "/setup/genimpo";

  versione() {
    return http.get(this.url + '/versione');
  }
  multilingua() {
    return http.get(this.url + '/multilingua');
  }
}

export default new service();